export interface ITimeTrackingNavItem {
	key: 'timesheet' | 'hoursReview';
	name: string;
	path: string;
	badge: number;
	ariaLabel: string;
}

export function getTimeTrackingNavItems({
	showTimesheet,
	showHoursReview,
	overdueCount,
	reviewCount,
}: {
	showTimesheet: boolean;
	showHoursReview: boolean;
	overdueCount: number;
	reviewCount: number;
}): ITimeTrackingNavItem[] {
	const items: ITimeTrackingNavItem[] = [];
	if (showTimesheet) {
		items.push({
			ariaLabel: overdueCount ? `Timesheet, ${overdueCount} overdue` : 'Timesheet',
			badge: overdueCount,
			key: 'timesheet',
			name: 'Timesheet',
			path: '/timesheet',
		});
	}
	if (showHoursReview) {
		items.push({
			ariaLabel: reviewCount ? `Hours review, ${reviewCount} waiting` : 'Hours review',
			badge: reviewCount,
			key: 'hoursReview',
			name: 'Hours review',
			path: '/hours-review',
		});
	}
	return items;
}

export function insertBefore<T>(items: T[], inserted: T[], isAnchor: (item: T) => boolean) {
	const index = items.findIndex(isAnchor);
	const at = index === -1 ? items.length : index;
	return [...items.slice(0, at), ...inserted, ...items.slice(at)];
}
